import React from 'react';

const Logo = props => (
    <i><b>Supply & Warehouse Management</b></i>
);

export default Logo;